export default {
  regular: 300,
  medium: 500,
  bold: 600,
  extra_bold: 800,
};
